module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "col-xs-12 col-sm-5"
  }, [_c('div', {
    staticClass: "calendar__info"
  }, [_c('div', {
    staticClass: "calendar__info__item"
  }, [_c('h4', {
    staticClass: "calendar__info__title"
  }, [_vm._v(_vm._s(_vm.$t('FIRST_PERIOD_DAY')))]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__date__wrapper"
  }, [_c('div', {
    staticClass: "calendar__info__date"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.firstPeriodDay, 'dd')))]), _vm._v(" "), _c('span', {
    staticClass: "date__day-number"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.firstPeriodDay, 'DD')))])]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__month"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.firstPeriodDay, 'MMM')) + " " + _vm._s(_vm._f("moment")(_vm.firstPeriodDay, 'YYYY')))])])]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__tooltip box-shadow"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('FIRST_PERIOD_DAY_INFO')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__item"
  }, [_c('div', {
    staticClass: "next-examination__wrapper"
  }, [_c('h4', {
    staticClass: "calendar__info__title"
  }, [_vm._v(_vm._s(_vm.$t('NEXT_BRASTER_EXAMINATION')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "next-examination__legend"
  }), _vm._v(" "), (_vm.firstAllowedDay) ? _c('div', {
    staticClass: "next-examination__date"
  }, [_vm._v("\n                    " + _vm._s(_vm.dateFormat(_vm.firstAllowedDay)) + "-" + _vm._s(_vm.dateFormat(_vm.lastAllowedDay)) + "\n                    "), _c('a', {
    staticClass: "trigger",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showVideo()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('HOW_TO_MAKE_EXAMINATION')) + "\n                        "), _c('img', {
    staticClass: "link-img",
    attrs: {
      "src": "/src/assets/images/arrow-red.png"
    }
  })])]) : _c('div', {
    staticClass: "next-examination__date"
  }, [_c('span', {
    staticClass: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('SELECT_DATE_FROM_CALENDAR')))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32319306","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/period-modules/braster-allowed.vue
// module id = 1181
// module chunks = 0